export const PATH_PSYCHOMETRIC_TEST = '/psychometric';
export const PATH_PSYCHOMETRIC_RESULT = '/psychometric/details';
export const PATH_PSYCHOMETRIC_RESULT_WITH_TOKEN =
    '/psychometric/details/:token([a-zA-Z0-9]+)';
export const PATH_PSYCHOMETRIC_START = '/psychometric/start';
